<svelte:options accessors={true}/>


<script>

    import { fade } from 'svelte/transition';
    import {afterUpdate, createEventDispatcher} from "svelte"
    import { chartOptions } from "../../utils/charts";
    import { onMount } from "svelte"
    import {isFilterDefault} from "./filter";

    const dispatch = createEventDispatcher();

    const FILTER_TEXTS = {
        'all': 'Alle',
        'rating': 'Bewertung',
        'topten': 'Top 10',
        'known': 'Bekannt',
        'gender': 'Geschlecht',
        'platform': 'Portal',
        'age': 'Alter',
        'origin': 'Herkunft',
        'sentiment': 'Stimmung',
        'unknown': 'Unbekannt',
        'woman': 'Frauen',
        'man': 'Männer',
        'tripadvisor': 'Tripadvisor',
        'google': 'Google',
        'facebook': 'Facebook'
    };

    const DEFAULT_FILTER_TEXT = {
        'platform': 'Alle Portale',
        'rating': 'Alle Bewertungen',
        'age': 'Alle Alter',
        'gender': 'Alle Geschlechter',
        'origin': 'Alle Herkünfte',
        'sentiment': 'Alle Stimmungen'
    }


    export let data;

    let checked = true;

    let showMenu = true;
    let showReset = false;

    let options = JSON.parse(JSON.stringify(chartOptions));

    $: optionSettings = data['settings']['filters'];

    let filterMeta = data['filter'];


    onMount(() => {

        //
    });


    let checkFilterOptions = () => {

        for (let item of optionSettings) {

            if (!(item in filterMeta)) {

                if (item === 'sentiment') {

                    filterMeta[item] = {
                        'positiv': null,
                        'negativ': null
                    }
                }

            }
        }

    };

    $: data && checkFilterOptions();

    let viewOption = 'all';

    let expandDropdown = (e) => {

        let target = e.currentTarget;

        document.querySelectorAll('.expanded').forEach(element => {

            if (element !== target) {
                element.classList.toggle('expanded');
                // element.classList.toggle('arrow-expand');

            }

        });

        target.classList.toggle('expanded');

    };

    let triggerMenu = (e) => {

        showMenu = !showMenu;
    };

    let assembleOptions = (value, key = false) => {

        if (!key) {

            options['display'] = value;
            eventDispatcher();

            return;

        }

        showReset = true;

        if (options['filter'][key] !== value) {

            if (typeof value === "object") {

                options['filter'][key] = 'all';
                eventDispatcher();

                return;

            }

            if (key === 'sentiment') {

                if (value === 'all') {
                    options['filter'][key] = value

                    eventDispatcher();
                    return;
                }

                options['filter'][key] = (value.startsWith('pos')) ? 'pos' : 'neg';
                eventDispatcher();

                return;

            }

            if (key === 'rating' && value !== 'all') {

                options['filter'][key] = parseInt(value);
                eventDispatcher();

                return;

            }

            options['filter'][key] = value;
            eventDispatcher();

        }

        if (isFilterDefault(options['filter'])) {

            showReset = false;
        }

    };

    export let resetFilter = (parent = false) => {

        for (let [filterKey ,filterVal] of Object.entries(options['filter'])) {

            options['filter'][filterKey] = 'all';
        }

        showReset = false;

        if (!parent) {
            eventDispatcher();
        }

    };

    let eventDispatcher = () => {

        dispatch('filtersMenu', {map: options});
    };


</script>

<div id="filter-menu" class:active={showMenu}>

    <div id="filter-button" on:click|stopPropagation={triggerMenu}>

        <img src="images/icon-filter.svg" alt="" />

    </div>
    
    {#if showMenu}
        
        {#if data['settings']['displays'].length > 1}

            <div id="display">

                <div class="menu-title">Darstellung</div>

                <div id="display-list">

                    {#each data['settings']['displays'] as view}

                        <div class="list-item">

                            <label>{FILTER_TEXTS[view]}</label>
                            {#if view === 'all'}
                                <input bind:group={viewOption} on:input={() => assembleOptions(view)} type="radio" name="display" value={view}>
                            {:else}
                                <input bind:group={viewOption} on:input={() => assembleOptions(view)} type="radio" name="display" value={view}>
                            {/if}

                            <div class="radio"></div>

                        </div>

                    {/each}

                </div>


            </div>

        {/if}


        <div id="filter">

            <div class="menu-title">Filter</div>

            <div id="filter-list">

                <!--{#each Object.entries(data['settings']) as [groupKey, groupItem], index(groupKey)}-->
                {#each optionSettings as groupKey, i}

                    <div class="filter-group" on:click={expandDropdown}>

                        {#if options['filter'][groupKey] !== 'all'}

                            {#if groupKey === 'rating'}

                                {#if options['filter'][groupKey] === '1'}

                                    <span class="item-display">{FILTER_TEXTS[options['filter'][groupKey]] + ' Stern'}</span>

                                {:else}

                                    <span class="item-display">{FILTER_TEXTS[options['filter'][groupKey]] + ' Sterne'}</span>

                                {/if}

                            {:else}
                                <span class="item-display">{FILTER_TEXTS[options['filter'][groupKey]]}</span>
                            {/if}

                        {:else}
                            <span class="item-display">{FILTER_TEXTS[groupKey]}</span>
                        {/if}

                        <img class="arrow-expand" src="images/arrow-change-down.svg" />

                        <div class="dropdown">

                            <div class="filter-item active" data-filter="all" on:click={() => assembleOptions('all', groupKey)}>{DEFAULT_FILTER_TEXT[groupKey]}</div>
                            
                            {#each Object.entries(filterMeta[groupKey]) as [filterKey, filterItem], index(filterKey)}

                                <div class="filter-item" data-filter={filterKey} on:click={() => assembleOptions(filterKey, groupKey)}>

                                    {#if filterItem !== null && !showReset}
                                        <span class="filter-count">(<span class="filter-num">{filterItem}</span>)</span>
                                    {/if}


                                    {#if groupKey === 'rating'}

                                        {#if filterKey === '1'}

                                            <span class="filter-id">{filterKey} Stern</span>

                                        {:else}

                                            <span class="filter-id">{filterKey} Sterne</span>

                                        {/if}

                                    {:else}

                                        {#if groupKey === 'gender'}

                                            <span class="filter-id">{FILTER_TEXTS[filterKey]}</span>

                                        {:else}

                                            {#if filterKey === 'unknown'}

                                                <span class="filter-id">{FILTER_TEXTS[filterKey]}</span>

                                            {:else}

                                                <span class="filter-id">{filterKey}</span>

                                            {/if}

                                        {/if}

                                    {/if}

                                </div>

                            {/each}

                        </div>

                    </div>

                {/each}

            </div>

            {#if showReset}

                <div on:click={() => resetFilter()} id="filter-reset">Alle Filter zurücksetzen</div>

            {/if}



        </div>
        
    {/if}
    

</div>

<style>

    #filter-menu {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        right: 4.53vh;
        height: 100vh;
        font-family: 'Raleway', sans-serif;
        z-index: 998;
    }

    #filter-menu *{
        transition: all 0.3s ease;
    }

    #filter-menu.active #display.show,
    #filter-menu.active #filter.show {
        display: flex;
    }

    #filter-menu.active {
        display: flex;
    }

    #filter-menu > div {
        margin-bottom: 1.6vh;
    }

    #filter-menu #filter-button {
        position: relative;
        display: flex;
        justify-content: center;
        width: 4.62vh;
        height: 4.62vh;
        background-color: #FFFFFF;
        border-radius: 1.39vh;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        cursor: pointer;
    }

    #filter-menu #filter-button img {
        width: 2.04vh;
        transition: none;
    }

    #filter-menu.active #filter-button img,
    #filter-menu #filter-button:hover img {
        filter: invert(78%) sepia(47%) saturate(4912%) hue-rotate(151deg) brightness(108%) contrast(82%);
    }

    #filter-menu #display,
    #filter-menu #filter {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        padding: 1.85vh;
        background-color: #FFFFFF;
        border-radius: 1.39vh;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
    }

    #filter-menu div#filter {
        padding: 1.85vh 1.85vh 1.33vh 1.85vh;
    }

    #filter-menu .menu-title {
        margin-bottom: 2.67vh;
        font-weight: 500;
        font-size: 1.78vh;
        text-align: center;
    }

    #display-list {
        position: relative;
        display: flex;
        flex-direction: column;
    }

    #display-list .list-item {
        position: relative;
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 1.11vh;
    }

    /*#display-list .list-item.show {*/
    /*    display: flex;*/
    /*}*/

    #display-list .list-item:last-child {
        margin-bottom: 0;
    }

    #display-list .list-item label {
        position: relative;
        padding-left: 1.11vh;
        font-weight: 400;
        font-size: 1.78vh;
    }
    #display-list .list-item label::first-letter {
        text-transform: capitalize;
    }

    #display-list .list-item input {
        position: absolute;
        opacity: 0;
        width: 100%;
        left: 0;
        margin: 0;
        cursor: pointer;
        user-select: none;
    }

    #display-list .list-item .radio {
        width: 1.78vh;
        height: 1.78vh;
        background-image: url(../images/icon-checkbox.svg);
        background-size: contain;
        background-repeat: no-repeat;
    }

    #display-list .list-item input:checked + .radio {
        background-image: url(../images/icon-checkbox-active.svg);
    }

    #filter-list .filter-group {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        width: 100%;
        min-width: 14.22vh;
        padding: 0.73vh 1.85vh;
        margin-bottom: 1.39vh;
        background-color: #FFFFFF;
        border-radius: 1.39vh;
        font-size: 1.78vh;
        font-weight: 400;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        transition: all 0.3s ease;
    }

    #filter-list .filter-group:hover {
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.19);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.19);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.19);
    }

    /*#filter-list .filter-group.show {*/
    /*    display: flex;*/
    /*}*/

    #filter-list .filter-group:last-child {
        margin-bottom: 0;
    }

    #filter-list .filter-group img {
        z-index: 1;
    }
    .filter-group :global(.dropdown)  {
        position: absolute;
        display: none;
        flex-direction: column;
        width: 100%;
        min-height: 100%;
        left: 0;
        top: calc(100% + 0.89vh);
        background-color: #FFFFFF;
        border-radius: 1.39vh;
        font-family: 'Raleway', sans-serif;
        font-size: 1.78vh;
        font-weight: 400;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        cursor: pointer;
    }

    #filter-list :global(.expanded .dropdown) {
        display: flex;
        z-index: 3;
    }

    #filter-list :global(.expanded .arrow-expand) {
        transform: translate(0, -50%) rotate(90deg);
    }

    .arrow-expand {
        position: absolute;
        display: flex;
        height: 0.89vh;
        top: 50%;
        right: 1.78vh;
        transform: translate(0, -50%);
    }

    .filter-group .dropdown {
        left: -0.89vh;
        top: calc(100% + 0.71vh);
        width: calc(100% + 1.78vh);
        max-height: 17.78vh;
        overflow-y: scroll;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);

    }

    .filter-group .filter-item {
        padding: 1.33vh 1.78vh;
        cursor: pointer;
        user-select: none;
    }

    .filter-group .filter-item.active,
    .filter-group .filter-item:hover {
        font-weight: 500;
    }

    .filter-item .filter-count {
        padding-right: 0.44vh;
        font-weight: 300;
    }

    .filter-item .filter-count.hide {
        display: none;
    }
    .filter-item .filter-id {
        text-transform: capitalize;
    }

    .filter-item .filter-count .filter-num {
        font-weight: 500;
    }

    .filter-group .item-display {
        width: 12.44vh;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        user-select: none;
    }

    #filter-reset {
        display: block;
        padding-top: 1.78vh;
        font-weight: 500;
        font-size: 1.42vh;
        text-align: center;
        cursor: pointer;
    }

    .filter-group .item-display::first-letter {
        text-transform: capitalize;
    }

</style>